import Lottie from "lottie-react";
import classNames from "classnames";

import animationData from "assets/animation/chart-animation.json";
import { COUNT_COMPLETED_TASKS, COUNT_EXCHANGE_USAGE } from "utils/helpers";

import "./IntroAnimation.scss";

export default function IntroAnimation({ className }) {
  const options = {
    animationData: animationData,
    loop: false,
    autoplay: true,
  };

  return (
    <div className={classNames("intro-animation", className)}>
      <div className="intro-animation__info">
        <p>{COUNT_EXCHANGE_USAGE.toLocaleString()}</p>
        <span>воспользовались биржей Boostclick</span>
      </div>
      <div className="intro-animation__info">
        <p>{COUNT_COMPLETED_TASKS.toLocaleString()}</p>
        <span>завершенных заданий</span>
      </div>
      <div className={classNames("intro-animation__lottie", className)}>
        <Lottie {...options} />
      </div>
    </div>
  );
}
